import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

function TypingIntros() {
  const lines = [
    '🖐️ Hello! I’m the Deduplication Agent.',
    '🔍 I find and merge duplicates to ensure clean, consistent master data.',
  ];


  const [displayedText, setDisplayedText] = useState(['', '']);
  const [lineIndex, setLineIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    if (lineIndex >= lines.length) return;

    if (charIndex < lines[lineIndex].length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => {
          const updated = [...prev];
          updated[lineIndex] += lines[lineIndex][charIndex];
          return updated;
        });
        setCharIndex((prev) => prev + 1);
      }, 40);

      return () => clearTimeout(timeout);
    }

    // Move to next line
    setLineIndex((prev) => prev + 1);
    setCharIndex(0);
  }, [charIndex, lineIndex, lines]);

  return (
    <Box
      sx={{
        backgroundColor: '#e0f2fe',
        color: '#0f172a',
        padding: 2,
        borderRadius: 2,
        fontWeight: 'bold',
        marginBottom: 2,
        border: '1px solid #90cdf4',
        fontFamily: 'monospace',
      }}
    >
      <h3>{displayedText[0]}</h3>
      <h3>{displayedText[1]}</h3>
    </Box>
  );
}

export default TypingIntros;
